import component from './container.vue'

export default component
